import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class OneTimePasswordData<T = any> {
  private _api = inject(FsApi);


  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `onetimepasswords/${id}`,
      query,
      {
        key: 'oneTimePassword',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'onetimepasswords',
      query,
      {
        key: 'oneTimePasswords',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'onetimepasswords',
      data,
      {
        key: null,
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `onetimepasswords/${data.id}`,
      data,
      {
        key: 'oneTimePassword',
        ...config,
      },
    );
  }

}
